import Link from "next/link";
import { useCallback, useContext, useEffect, useState } from "react";
import DiscountContext from "../../context/discount/DiscountContext";
import { SubscriptionIcon } from "../icons/subscription";
import Hamburger from "./Hamburger";
import HamburgerMenu from "./HamburgetMenu";

const Sidebar = ({ tab }) => {
  const discountContext = useContext(DiscountContext);
  const {
    getTopbarAlert,
    topbarAlertStatus,
    checkQueueStatus,
    queueStatus,
    setHamburgetState,
  } = discountContext;

  const [selected, setSelected] = useState([
    true,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const [timer, setTimer] = useState("");


  const handleSelected = useCallback(
    (index) => {
      if (selected[index] === true) {
        return;
      }
      let newSelected = new Array(6).fill(false);
      newSelected[index] = true;
      setSelected(newSelected);
      setHamburgetState(false);
    },
    [selected]
  );

  const toggleHamburger = () => {
    let newValue = !hamburgerOpen;
    setHamburgerOpen(newValue);
    setHamburgetState(newValue);
  };

  useEffect(() => {
    handleSelected(tab);
  }, [tab]);

  useEffect(() => {
    let interval = setInterval(() => {
      getTopbarAlert();
      checkQueueStatus();
    }, 7000);
    return () => {
      clearInterval(interval);
      setTimer("");
    };
  }, []);

  const showMessage = () => {
    if (queueStatus.status == "processing")
      return (
        <>
          <div className="topbar-alart" style={{ background: "#fff9e5" }}>
            <div className="titleText text-center">
              {queueStatus.type == "store_sale" ? "Sale" : queueStatus.type==="bulk_discount"? "Bulk Discount" : "Price Change"} is
              being {queueStatus.state == "reverting" ? "reverted" : "applied"},
              {innerWidth < 400 && <br />} please don't make any changes to your
              products in Shopify
            </div>
          </div>
        </>
      );
    else if (topbarAlertStatus == "syncing") {
      return (
        <>
          <div className="topbar-alart" style={{ background: "#fff9e5" }}>
            <div className="titleText">
              Store products information is currently syncing with the database.
              Please wait for it to complete before creating any new promotion
              to ensure accurate filtering.
            </div>
          </div>
        </>
      );
    } else return <></>;
  };

  return (
    <>
      {showMessage()}
      <div
        className="sidenav"
        style={
          hamburgerOpen
            ? { borderBottom: "none" }
            : { borderBottom: "solid 3px white" }
        }
      >
        <div className="link ">
          <Link href="/">
            <a href="#">
              <img
                className="logo"
                src="/img/app-logo.png"
                alt="Logo"
              />
            </a>
          </Link>
        </div>

        <div className="app-name-navbar">
          <Link href="/">
            <div className="title app-name-title">Bevy Sales Rules</div>
          </Link>
        </div>

        {/* <hr className="logo-hr" /> */}
        <div className="logo-icon-hr" />

        <div
          onClick={() => handleSelected(0)}
          className={
            selected[0]
              ? "link link-selected navbar-content"
              : "link navbar-content"
          }
        >
          <Link href="/">
            <a className={selected[0] ? "" : "link-icon--inactive"} href="#">
              <svg
                className={
                  selected[0] ? "svg-icon--active" : "svg-icon--inactive"
                }
                fill={selected[0] ? "#4765f0" : "#081e57"}
                viewBox="0 0 32 30"
                height="30px"
                width="30px"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M15.5 0C7 0 0 7 0 15.5C0 24.1 7 31 15.5 31C24 31 31 24 31 15.5C31.1 7 24.1 0 15.5 0ZM15.5 29.2C8 29.2 1.9 23 1.9 15.5C1.9 8 8 1.9 15.5 1.9C23 1.9 29.2 8 29.2 15.5C29.2 23 23 29.2 15.5 29.2Z"/>
                <path d="M22.2 14.6H16.5V8.79999C16.5 8.29999 16.1 7.79999 15.5 7.79999C14.9 7.79999 14.5 8.19999 14.5 8.79999V14.5H8.79999C8.29999 14.5 7.79999 14.9 7.79999 15.5C7.79999 16.1 8.19999 16.4 8.79999 16.4H14.5V22.1C14.5 22.6 14.9 23.1 15.5 23.1C16.1 23.1 16.5 22.7 16.5 22.1V16.4H22.2C22.7 16.4 23.2 16 23.2 15.5C23.2 15 22.7 14.6 22.2 14.6Z"/>
              </svg>
              <br />
              <br />
              {selected[0] ? (
                <h4 className="sidebar-text-selected">New</h4>
              ) : (
                <h4 className="sidebar-text">New</h4>
              )}
            </a>
          </Link>
        </div>

        {/* <hr className="active-hr" /> */}
        <div className="icon-hr" />

        <div
          onClick={() => handleSelected(2)}
          className={
            selected[2]
              ? "link link-selected navbar-content"
              : "link navbar-content"
          }
        >
          <Link href="/Logs">
            <a className={selected[2] ? "" : "link-icon--inactive"} href="#">
              <svg
                className={
                  selected[2] ? "svg-icon--active" : "svg-icon--inactive"
                }
                fill={selected[2] ? "#4765f0" : "#081e57"}
                id="bold"
                viewBox="0 0 33 23"
                height="30px"
                width="30px"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12.7679 15.4418C12.2768 15.4418 11.7857 15.8116 11.7857 16.3664V17.5685H3.14286C2.45536 17.5685 1.86607 17.0137 1.86607 16.3664V13.3151C3.73214 12.9452 5.00893 11.4658 5.00893 9.7089C5.00893 7.85959 3.63393 6.38014 1.86607 5.91781V2.9589C1.86607 2.31164 2.45536 1.75685 3.14286 1.75685H11.7857V3.2363C11.7857 3.69863 12.1786 4.16096 12.7679 4.16096C13.3571 4.16096 13.75 3.7911 13.75 3.2363V1.75685H23.7679C24.4554 1.75685 25.0446 2.31164 25.0446 2.9589V6.38014C24.2589 6.56507 23.0804 6.84247 21.8036 7.48973C21.3125 7.67466 21.2143 8.22945 21.4107 8.69178C21.6071 8.96918 21.9018 9.15411 22.1964 9.15411C22.2946 9.15411 22.4911 9.15411 22.5893 9.06164C24.2589 8.22945 26.0268 8.04452 26.0268 8.04452C26.5179 7.95205 26.8125 7.58219 26.8125 7.21233V2.9589C26.8125 1.29452 25.4375 0 23.6696 0H3.14286C1.375 0 0 1.29452 0 2.9589V6.75C0 7.21233 0.392857 7.67466 0.982143 7.67466C2.25893 7.67466 3.14286 8.59931 3.14286 9.80137C3.14286 10.911 2.16071 11.8356 0.982143 11.8356C0.491071 11.8356 0 12.2055 0 12.7603V16.5514C0 18.2158 1.375 19.5103 3.14286 19.5103H12.7679C13.2589 19.5103 13.75 19.1404 13.75 18.5856V16.4589C13.75 15.8116 13.3571 15.4418 12.7679 15.4418Z" />
                <path d="M24.2589 10.541C19.4464 10.541 15.5179 14.2396 15.5179 18.7705C15.5179 23.3013 19.4464 26.9999 24.2589 26.9999C29.0714 26.9999 33 23.3013 33 18.7705C33 14.2396 29.0714 10.541 24.2589 10.541ZM24.2589 25.2431C20.5268 25.2431 17.3839 22.3766 17.3839 18.7705C17.3839 15.1643 20.4286 12.2979 24.2589 12.2979C28.0893 12.2979 31.1339 15.1643 31.1339 18.7705C31.1339 22.3766 28.0893 25.2431 24.2589 25.2431Z" />
                <path d="M12.6696 6.10278C12.1786 6.10278 11.6875 6.47265 11.6875 7.02744V12.2055C11.6875 12.6679 12.0804 13.1302 12.6696 13.1302C13.2589 13.1302 13.6518 12.7603 13.6518 12.2055V6.93498C13.6518 6.47265 13.2589 6.10278 12.6696 6.10278Z" />
                <path d="M25.2411 18.4007V14.0548C25.2411 13.5925 24.8482 13.1301 24.2589 13.1301C23.6697 13.1301 23.2768 13.5 23.2768 14.0548V18.7705C23.2768 19.0479 23.375 19.2329 23.5714 19.4178L25.3393 21.0822C25.5357 21.2671 25.7322 21.3596 26.0268 21.3596C26.3214 21.3596 26.5179 21.2671 26.7143 21.0822C27.1072 20.7123 27.1072 20.1575 26.7143 19.8801L25.2411 18.4007Z" />
              </svg>
              <br />
              <br />
              {selected[2] ? (
                <h4 className="sidebar-text-selected">Logs</h4>
              ) : (
                <h4 className="sidebar-text">Logs</h4>
              )}
            </a>
          </Link>
        </div>

        {/* <hr className="active-hr" /> */}
        <div className="icon-hr" />

        <div
          onClick={() => handleSelected(3)}
          className={
            selected[3]
              ? "link link-selected navbar-content"
              : "link navbar-content"
          }
        >
          <Link href="/StoreFrontDesigns">
            <a className={selected[3] ? "" : "link-icon--inactive"} href="#">
            <svg 
              className={
                selected[3] ? "svg-icon--active" : "svg-icon--inactive"
              }
              fill={selected[3] ? "#4765f0" : "#081e57"}
              id="bold"
              viewBox="0 0 33 32"
              height="30px"
              width="30px"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M32.0331 22.4845C31.891 23.0188 31.7154 23.5277 31.3642 23.9603C30.2019 25.3767 28.1533 25.4276 26.874 24.0536C25.0595 22.1113 23.245 20.1605 21.4473 18.2098C21.2633 18.0147 21.1212 17.9808 20.8871 18.091C20.0175 18.4727 19.5158 19.3887 19.6746 20.3302C19.8586 21.4073 20.6028 22.0943 21.648 22.1622C21.9824 22.1876 22.3169 22.1876 22.6346 22.2724C24.0394 22.6541 24.8588 23.6125 25.1097 25.0374C25.3438 26.4029 24.9006 27.5649 23.7718 28.3707C22.158 29.5241 20.3603 30.2875 18.4287 30.6692C13.5957 31.6191 9.23096 30.5589 5.42642 27.3614C2.49149 24.8848 0.735554 21.6872 0.175325 17.862C-0.794623 11.221 2.3159 4.97011 8.11886 1.78106C13.3532 -1.09418 20.1262 -0.441106 24.8254 3.39255C27.2001 5.32634 28.8724 7.76054 29.7922 10.6951C30.4778 12.8664 29.7922 15.1734 28.0781 16.6322C28.0195 16.6831 27.9694 16.7255 27.8439 16.8443C27.9526 16.9121 28.053 16.963 28.1366 17.0393C28.9477 17.8112 29.742 18.6084 30.5782 19.3633C31.2806 19.9994 31.8659 20.6864 32.0331 21.6533C32.0331 21.9332 32.0331 22.2046 32.0331 22.4845ZM26.4726 15.4533C27.9025 14.5458 28.5045 12.8155 27.9777 11.1871C25.9208 4.80896 19.382 0.882013 12.8766 2.12032C6.13716 3.40103 1.42957 9.55862 1.91454 16.488C2.16539 20.0418 3.5785 23.0697 6.16224 25.47C9.41492 28.4894 13.2696 29.5835 17.6177 28.8711C19.3987 28.5827 21.0376 27.8957 22.551 26.8949C23.2032 26.4623 23.4374 25.7499 23.1698 25.0459C22.9273 24.4098 22.434 24.0875 21.648 24.062C18.9555 23.9857 17.1076 21.331 17.9438 18.7611C18.2699 17.7603 18.9054 17.0139 19.8168 16.4796C19.106 15.7162 18.4037 14.9614 17.7013 14.215C17.6427 14.1556 17.5173 14.1556 17.4253 14.1556C16.8735 14.1471 16.3133 14.215 15.7781 14.1132C14.0807 13.7909 12.9602 12.7646 12.3498 11.1192C11.5973 9.08366 11.2294 6.96327 10.9785 4.81744C10.8949 4.07955 11.3883 3.5961 12.1157 3.69788C12.793 3.79118 13.4787 3.88448 14.156 4.00322C15.6945 4.27463 17.2079 4.63933 18.6629 5.25848C20.6446 6.08967 21.5811 8.28639 21.2633 10.1863C21.2299 10.3728 21.2801 10.5001 21.4138 10.6273C22.1831 11.3567 22.9524 12.0946 23.7133 12.824C24.6414 13.6976 25.5528 14.5712 26.4726 15.4533ZM13.0021 5.72497C13.0271 5.92852 13.0439 6.03878 13.0606 6.14904C13.3114 7.64179 13.5874 9.12606 14.1392 10.534C14.6493 11.8317 15.7447 12.4508 17.0992 12.2557C18.295 12.0861 19.2733 11.0683 19.4321 9.81307C19.5659 8.75287 19.0893 7.42127 17.8267 6.95479C17.1327 6.70034 16.4303 6.46286 15.7112 6.28475C14.8416 6.08119 13.9469 5.92852 13.0021 5.72497ZM19.5241 13.3753C20.77 14.7154 22.066 16.1064 23.3621 17.4973C24.9926 19.253 26.6231 21.0002 28.2536 22.7559C28.5714 23.0951 28.956 23.2224 29.3908 23.0867C29.8089 22.9679 30.0598 22.6541 30.135 22.23C30.2103 21.806 30.0347 21.4752 29.7337 21.1868C26.966 18.5406 24.1983 15.8858 21.4306 13.2396C21.1045 12.9258 20.7784 12.6205 20.5191 12.366C20.1763 12.7138 19.8586 13.036 19.5241 13.3753Z"/>
              <circle cx="7" cy="15" r="2"/>
              <circle cx="11" cy="22" r="2"/>
            </svg>

              <br />
              <br />
              {selected[3] ? (
                <h4 className="sidebar-text-selected">Appearance</h4>
              ) : (
                <h4 className="sidebar-text">Appearance</h4>
              )}
            </a>
          </Link>
        </div>

        <div className="icon-hr" />

        <div
          onClick={() => handleSelected(4)}
          className={
            selected[4]
              ? "link link-selected navbar-content"
              : "link navbar-content"
          }
        >
          <Link href="/Academy">
            <a className={selected[4] ? "" : "link-icon--inactive"} href="#">
              <svg
                className={
                  selected[4] ? "svg-icon--active" : "svg-icon--inactive"
                }
                fill={selected[4] ? "#4765f0" : "#081e57"}
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                //xmlns="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                height="30px"
                width="30px"
                viewBox="0 0 512 512"
              >
                <g>
                  <g>
                    <path
                      d="M 429.90,460.10
                C 429.90,460.10 95.70,460.10 95.70,460.10
                  78.30,460.10 82.00,448.70 82.00,435.30
                  82.00,435.30 82.00,130.00 82.00,130.00
                  88.20,132.10 94.80,133.30 101.60,133.30
                  101.60,133.30 429.90,133.30 429.90,133.30
                  429.90,133.30 429.90,460.10 429.90,460.10 Z
                M 101.60,51.90
                C 101.60,51.90 390.50,51.90 390.50,51.90
                  382.90,63.40 382.90,81.20 393.20,92.50
                  393.20,92.50 101.60,92.50 101.60,92.50
                  90.80,92.50 82.00,83.60 82.00,72.20
                  81.90,60.80 90.70,51.90 101.60,51.90
                  101.60,51.90 101.60,51.90 101.60,51.90 Z
                M 449.50,87.60
                C 449.10,87.60 443.40,87.60 443.20,87.60
                  433.60,87.20 426.00,79.40 426.00,69.80
                  426.00,60.60 433.00,53.00 441.90,52.10
                  441.90,52.10 447.80,52.00 447.80,52.00
                  459.10,52.00 468.30,42.90 468.30,31.60
                  468.30,20.30 459.10,11.20 447.80,11.20
                  447.80,11.20 101.60,11.20 101.60,11.20
                  68.20,11.00 41.00,38.10 41.00,71.40
                  41.00,71.40 41.00,435.30 41.00,435.30
                  41.00,471.50 55.40,500.90 95.70,500.90
                  95.70,500.90 450.20,500.90 450.20,500.90
                  461.40,500.90 470.60,491.80 470.70,480.60
                  470.70,480.60 470.40,110.40 470.40,110.40
                  470.40,97.90 461.20,87.60 448.90,87.60
                  448.90,87.60 449.50,87.60 449.50,87.60 Z
                M 157.10,358.30
                C 157.10,358.30 344.90,358.30 344.90,358.30
                  356.20,358.30 365.40,349.20 365.40,337.90
                  365.40,326.60 356.20,317.50 344.90,317.50
                  344.90,317.50 157.10,317.50 157.10,317.50
                  145.80,317.50 136.60,326.60 136.60,337.90
                  136.60,349.20 145.80,358.30 157.10,358.30
                  157.10,358.30 157.10,358.30 157.10,358.30 Z
                M 157.10,254.10
                C 157.10,254.10 344.90,254.10 344.90,254.10
                  356.20,254.10 365.40,245.00 365.40,233.70
                  365.40,222.40 356.20,213.30 344.90,213.30
                  344.90,213.30 157.10,213.30 157.10,213.30
                  145.80,213.30 136.60,222.40 136.60,233.70
                  136.60,245.00 145.80,254.10 157.10,254.10
                  157.10,254.10 157.10,254.10 157.10,254.10 Z"
                    />
                  </g>
                </g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
              </svg>
              <br />
              <br />
              {selected[4] ? (
                <h4 className="sidebar-text-selected">Academy</h4>
              ) : (
                <h4 className="sidebar-text">Academy</h4>
              )}
            </a>
          </Link>
        </div>
        <div class="icon-hr"></div>
        <div
          // style={{  }}
          onClick={() => handleSelected(5)}
          className={
            selected[5]
              ? "link link-selected navbar-content"
              : "link navbar-content"
          }
        >
          <Link href="/Subscription">
            <a className={selected[5] ? "" : "link-icon--inactive"} href="#">
              <SubscriptionIcon selected={selected[5]} />
              <br />
              <br />
              {selected[5] ? (
                <h4 className="sidebar-text-selected">Subscription</h4>
              ) : (
                <h4 className="sidebar-text">Subscription</h4>
              )}
            </a>
          </Link>
        </div>

        <div className="hamburger" onClick={toggleHamburger}>
          <Hamburger isOpen={hamburgerOpen} />
        </div>
      </div>

      {hamburgerOpen ? (
        <HamburgerMenu
          open={hamburgerOpen}
          selected={selected}
          handleSelected={handleSelected}
        />
      ) : null}
    </>
  );
};

export default Sidebar;
